// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__hCAHd","navLinks":"Navbar_navLinks__30UTV","link":"Navbar_link__I558x","activeLink":"Navbar_activeLink__xmyeA"};